import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { listMyRestaurants } from '../services/api';
import Icon from './Icon';
import { storage } from '../utils/storage';
import './RestaurantSelector.css';

function RestaurantSelector() {
  const { t } = useTranslation();
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState('');
  const [loading, setLoading] = useState(true);
  const [allRestaurants, setAllRestaurants] = useState(false);

  useEffect(() => {
    loadRestaurants();
    // Obtener restaurante seleccionado del localStorage
    const savedRestaurantId = storage.get('selectedRestaurantId');
    if (savedRestaurantId) {
      setSelectedRestaurantId(savedRestaurantId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadRestaurants = async () => {
    try {
      // Obtener la organización seleccionada
      const organizationId = storage.get('selectedOrganizationId');

      if (!organizationId) {
        console.warn('No organization selected');
        setLoading(false);
        return;
      }

      // Llamar al nuevo endpoint de multi-tenancy
      const data = await listMyRestaurants(organizationId);
      const activeRestaurants = data.restaurants.filter(
        (r) => r.status === 'active' || r.status === 'inactive'
      );
      setRestaurants(activeRestaurants);
      setAllRestaurants(data.allRestaurants);

      // Si no hay restaurante seleccionado, seleccionar el primero activo
      const savedRestaurantId = storage.get('selectedRestaurantId');
      if (!savedRestaurantId && activeRestaurants.length > 0) {
        const firstActive =
          activeRestaurants.find((r) => r.status === 'active') || activeRestaurants[0];
        handleRestaurantChange(firstActive.restaurantId, activeRestaurants);
      }
    } catch (error) {
      console.error('Error loading restaurants:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRestaurantChange = (restaurantId, list = restaurants) => {
    setSelectedRestaurantId(restaurantId);
    storage.set('selectedRestaurantId', restaurantId);

    // Encontrar el restaurante seleccionado y guardar info adicional. `list`
    // permite resolver el nombre en la auto-selección inicial, cuando el state
    // todavía no se actualizó.
    const restaurant = list.find((r) => r.restaurantId === restaurantId);
    if (restaurant) {
      storage.set('selectedRestaurantName', restaurant.name);
    }

    // Recargar la página para aplicar cambios
    window.location.reload();
  };

  if (loading) {
    return <div className="restaurant-selector loading">{t('common.loading')}</div>;
  }

  const organizationId = storage.get('selectedOrganizationId');

  if (!organizationId) {
    return (
      <div className="restaurant-selector empty">
        <Icon name="store" size="small" />
        <span>Seleccione una organización primero</span>
      </div>
    );
  }

  if (restaurants.length === 0) {
    return (
      <div className="restaurant-selector empty">
        <Icon name="store" size="small" />
        <span>No hay restaurantes asignados</span>
      </div>
    );
  }

  const selectedRestaurant = restaurants.find((r) => r.restaurantId === selectedRestaurantId);

  return (
    <div className="restaurant-selector">
      <Icon name="store" size="small" />
      <select
        value={selectedRestaurantId}
        onChange={(e) => handleRestaurantChange(e.target.value)}
        className="restaurant-select"
      >
        <option value="">Seleccionar restaurante</option>
        {restaurants.map((restaurant) => (
          <option key={restaurant.restaurantId} value={restaurant.restaurantId}>
            {restaurant.name} {restaurant.status === 'inactive' ? '(Inactivo)' : ''}
          </option>
        ))}
      </select>
      {selectedRestaurant && (
        <span className="selected-restaurant-badge">
          {selectedRestaurant.status === 'active' ? '✓' : '⚠️'}
        </span>
      )}
      {allRestaurants && (
        <span className="all-access-badge" title="Acceso a todos los restaurantes">
          🔓
        </span>
      )}
    </div>
  );
}

export default RestaurantSelector;
